import React, { Component } from 'react'
import moment from 'moment'

class VisaView extends Component {

    render() {
        let visa = this.props.visaInfo;
        if (!visa) {
            return null;
        }

        return (
            <div>
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Страна</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{visa.country}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">С</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{moment(visa.startDate).format("DD.MM.yyyy")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">По</label>
                            <div className="form-element-data">
                                <div className="form-element-data-text">
                                    <p>{moment(visa.endDate).format("DD.MM.yyyy")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default VisaView
